import { render, staticRenderFns } from "./DateFormatter.vue?vue&type=template&id=d64a41e0&"
import script from "./DateFormatter.vue?vue&type=script&lang=js&"
export * from "./DateFormatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d64a41e0')) {
      api.createRecord('d64a41e0', component.options)
    } else {
      api.reload('d64a41e0', component.options)
    }
    module.hot.accept("./DateFormatter.vue?vue&type=template&id=d64a41e0&", function () {
      api.rerender('d64a41e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2x1PjXjplsCTb/JS/DateFormatter.vue"
export default component.exports